import { render, staticRenderFns } from "./apps.vue?vue&type=template&id=9139f658&scoped=true&"
import script from "./apps.vue?vue&type=script&lang=js&"
export * from "./apps.vue?vue&type=script&lang=js&"
import style0 from "./apps.vue?vue&type=style&index=0&id=9139f658&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9139f658",
  null
  
)

export default component.exports